import React from "react";
import makeValueChangeSpy from "../../../utils/makeValueChangeSpy";
import isInViewport from "../../../utils/isInViewport";
import getNearestNumber from "../../../utils/getNearestNumber";
import PropTypes from 'prop-types';

class ScrollingInspector extends React.Component {
  constructor() {
    super();
    const valueChangeSpy = makeValueChangeSpy(true);
    this.comparator = valueChangeSpy.comparator;
    this.registerCallback = valueChangeSpy.registerCallback
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.registerCallback(this.props.onVisibilityChange);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  setContainerReference = (ref) => {
    this.container = ref;
  }

  handleScroll = () => {
    const isElementInViewport = isInViewport(this.container);
    this.comparator(isElementInViewport);
  }

  getImageUrl = () => {
    if (!this.container) {
      return ""
    }

    const containerWidth = this.container.clientWidth;
    const width = getNearestNumber(Object.keys(this.props.thumbnails), containerWidth);
    return this.props.thumbnails[width];
  }

  render() {
    const { showPlaceholder } = this.props;

    return (
      <div
        ref={this.setContainerReference}
        className={`player-container ${showPlaceholder && "retainAspectRatio"}`}
      >
        {showPlaceholder && (
          <div
            id={`placeholder-${this.props.playerPlaceholderId}`}
            style={{background: `url(${this.getImageUrl()})`, backgroundSize: 'cover'}}
            className="ooyala-background-image-placeholder"
          />
        )}
        {this.props.children}
      </div>
    )
  }
}

ScrollingInspector.propTypes = {
  children: PropTypes.any,
  showPlaceholder: PropTypes.bool,
  thumbnails: PropTypes.object,
  onVisibilityChange: PropTypes.func,
  playerPlaceholderId: PropTypes.string
}

export default ScrollingInspector;



// WEBPACK FOOTER //
// ./modules/Ooyala/component/ScrollingInspector.js